import type { Id } from "storefront/lib/Id";
import { get } from "storefront/GrailedAPI/request";

type Response = {
  data: Record<string, Record<string, Array<"email" | "paypal">>>;
};

/**
 * @name GrailedAPI.v1.Internal.Users.getRelatedUsers
 * @link https://www.grailed.com/internal/api-docs#tag/Users/operation/getRelatedUsers
 */
const getRelatedUsers = (id: Id): Promise<Response> =>
  get(`/api/users/${id}/related_users`);

export default getRelatedUsers;
